import React from 'react';
import { CONTACTS } from '@department-of-veterans-affairs/component-library/contacts';
import PropTypes from 'prop-types';

import recordEvent from 'platform/monitoring/record-event';
import { VA_FORM_IDS } from 'platform/forms/constants';

const Alert = ({ content, title }) => (
  <div className="vads-l-grid-container vads-u-padding-left--0 vads-u-padding-bottom--5">
    <div className="usa-content">
      <h1>{title}</h1>
      <va-alert status="error" uswds>
        {content}
      </va-alert>
    </div>
  </div>
);

Alert.propTypes = {
  content: PropTypes.node,
  title: PropTypes.string,
};

export const MissingServices = ({
  title,
  formId = VA_FORM_IDS.FORM_21_526EZ,
}) => {
  const content = (
    <>
      <h2 className="vads-u-display--inline-block vads-u-font-size--h3 vads-u-margin-top--0">
        We need some information for your application
      </h2>
      <p className="vads-u-font-size--base">
        We’re missing your Participant ID, BIRLS ID, and/or EDIPI. We need this
        information before you can file for disability compensation with VA Form
        21-526EZ.
      </p>
      <p>
        Call us at <va-telephone contact="8662793677" /> (
        <va-telephone contact={CONTACTS['711']} tty />) to submit a request to
        update your information. We’re here Monday through Friday, 8:00 a.m. to
        8:00 p.m. ET. Tell the representative you need help getting this missing
        information added to your VA records so you can file VA Form 21-526EZ.
      </p>
    </>
  );
  recordEvent({
    event: 'visible-alert-box',
    'alert-box-type': 'warning',
    'alert-box-heading': title,
    'error-key': 'missing_526_or_original_claims_service',
    'form-id': formId,
    'alert-box-full-width': false,
    'alert-box-background-only': false,
    'alert-box-closeable': false,
  });
  return <Alert title={title} content={content} />;
};

MissingServices.propTypes = {
  title: PropTypes.string.isRequired,
  formId: PropTypes.string,
};
